import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    addFinance,
    fetchMonthlyFinance,
    resetFinance,
} from '../redux/slices/financeSlice.js';
import {
    Box,
    Input,
    Button,
    VStack,
    Text,
    Spinner,
    Card,
    CardBody,
    Divider,
    FormControl,
    FormLabel,
    Select,
    SimpleGrid,
    Container,
    Heading,
    useDisclosure,
    Modal,
    ModalBody,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalFooter
} from '@chakra-ui/react';
import React from 'react';
import axios from 'axios';
import { MdDeleteForever } from "react-icons/md";
import { HiPencilSquare } from "react-icons/hi2";




const FinanceReport = () => {
    const dispatch = useDispatch();
    const { summary, loading, error } = useSelector((state) => state.financeSlice);
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);  // ide jönnek a részletes adatok
    const { isOpen, onOpen, onClose } = useDisclosure();
    console.log(summary)
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!month || !year) return;
        dispatch(fetchMonthlyFinance({ year, month }));
    };

    const handleDeleteInvoice = async (id) => {
        try {
            await axios.delete(`/api/invoices/${id}`);
            dispatch(fetchMonthlyFinance({ year, month })); // frissítjük a listát
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteExpense = async (id) => {
        try {
            await axios.delete(`/api/expenses/${id}`);
            dispatch(fetchMonthlyFinance({ year, month })); // frissítjük a listát
        } catch (error) {
            console.error(error);
        }
    };



    const handleDeleteSale = async (id) => {
        const url = `/api/sales/${id}`;
        console.log("Törlés URL-je:", url); // itt látszik, milyen útvonalat próbál használni
        try {
            await axios.delete(url);
            dispatch(fetchMonthlyFinance({ year, month })); // frissítjük a listát
        } catch (error) {
            console.error(error);
        }
    };


    const handleSave = async () => {
        try {
            const updatedItem = {
                ...selectedItem,
                totalAmount: Object.values(selectedItem.amounts || {}).reduce((a, b) => a + b, 0)
            };

            let endpoint = "";

            if (updatedItem.supplier && updatedItem.category) {
                endpoint = `/api/invoices/${updatedItem._id}`;
            } else if (updatedItem.category && !updatedItem.supplier) {
                endpoint = `/api/expenses/${updatedItem._id}`;
            } else {
                endpoint = `/api/sales/${updatedItem._id}`;
            }
            // 3️⃣ PUT request
            await axios.put(endpoint, updatedItem);

            // 4️⃣ frissítés
            dispatch(fetchMonthlyFinance({ year, month }));
            onClose();
        } catch (err) {
            console.error(err);
        }
    };

    // --- SALES összesítése ---
    const totalSalesAmounts = summary?.sales?.reduce(
        (acc, item) => {
            Object.entries(item.amounts || {}).forEach(([key, value]) => {
                acc[key] = (acc[key] || 0) + value;
            });
            return acc;
        },
        { _0: 0, _5: 0, _18: 0, _27: 0 }
    );

    // --- INVOICES összesítése ---
    const totalInvoiceAmounts = summary?.invoices?.reduce(
        (acc, item) => {
            Object.entries(item.amounts || {}).forEach(([key, value]) => {
                acc[key] = (acc[key] || 0) + value;
            });
            return acc;
        },
        { _0: 0, _5: 0, _18: 0, _27: 0 }
    );

    // --- EXPENSES összesítése ---
    const totalExpensesAmounts = summary?.expenses?.reduce(
        (acc, item) => {
            Object.entries(item.amounts || {}).forEach(([key, value]) => {
                acc[key] = (acc[key] || 0) + value;
            });
            return acc;
        },
        { _0: 0, _5: 0, _18: 0, _27: 0 }
    );



    // --- VÉGÖSSZESÍTÉS ---
    const totalAllAmounts = {
        _0: totalSalesAmounts?._0 - totalInvoiceAmounts?._0,
        _5: totalSalesAmounts?._5 - totalInvoiceAmounts?._5,
        _18: totalSalesAmounts?._18 - totalInvoiceAmounts?._18,
        _27: totalSalesAmounts?._27 - totalInvoiceAmounts?._27,
    };





    return (
        <Box p={6} maxW="container.lg" mx="auto">
            <Heading textAlign="center" fontSize="2xl" fontWeight="extrabold">
                Admin Számlatörténet
            </Heading>
            <Container >
                <VStack as="form" spacing={3} onSubmit={handleSubmit}>
                    {/* Hónap */}
                    <FormControl>
                        <FormLabel>Hónap</FormLabel>
                        <Select value={month} onChange={(e) => setMonth(e.target.value)} placeholder="Válassz hónapot">
                            {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                                <option key={m} value={m < 10 ? `0${m}` : `${m}`}>
                                    {m < 10 ? `0${m}` : m}
                                </option>
                            ))}
                        </Select>
                    </FormControl>

                    {/* Év */}
                    <FormControl>
                        <FormLabel>Év</FormLabel>
                        <Select value={year} onChange={(e) => setYear(e.target.value)} placeholder="Válassz évet">
                            {Array.from({ length: 5 }, (_, i) => 2026 - i).map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                </option>
                            ))}
                        </Select>
                    </FormControl>

                    <Button type="submit" colorScheme="green" w="full">
                        Lekérés
                    </Button>
                </VStack>
            </Container>

            {loading && (
                <Box textAlign="center" mt={4}>
                    <Spinner size="lg" />
                </Box>
            )}

            {error && (
                <Text color="red.500" mt={4} textAlign="center">
                    {error}
                </Text>
            )}
            <Box>
                {summary && (
                    <Container maxW="container.lg">
                        {/* Összesítő Card */}
                        <Card mt={4}>
                            <CardBody>
                                <Text fontSize="xl" fontWeight="bold" mb={2}>
                                    📊 Összesítő ({month}/{year})
                                </Text>

                                <Text>💚 Bevétel (Sales): <b>{summary.totalIncome.toLocaleString('hu-HU')} Ft</b></Text>
                                <Text>📄 Számlák: <b>{summary.invoiceExpense.toLocaleString('hu-HU')} Ft</b></Text>
                                <Text>💸 Egyéb kiadás: <b>{summary.otherExpense.toLocaleString('hu-HU')} Ft</b></Text>
                                <Divider my={2} />
                                <Text>🔴 Összes kiadás: <b>{summary.totalExpense.toLocaleString('hu-HU')} Ft</b></Text>
                                <Text>📈 Nettó eredmény: <b>{summary.profit.toLocaleString('hu-HU')} Ft</b></Text>

                                {/* SALES */}
                                {summary.sales?.length > 0 && (
                                    <Box mt={4} p={3} bg="green.50" borderRadius="md">
                                        <Text fontWeight="bold" mb={2}>💰 Napi Forgalmi Jelentés:</Text>
                                        <Text>0% (DRS): <b>{totalSalesAmounts._0.toLocaleString('hu-HU')} Ft</b></Text>
                                        <Text>5%: <b>{totalSalesAmounts._5.toLocaleString('hu-HU')} Ft</b></Text>
                                        <Text>18%: <b>{totalSalesAmounts._18.toLocaleString('hu-HU')} Ft</b></Text>
                                        <Text>27%: <b>{totalSalesAmounts._27.toLocaleString('hu-HU')} Ft</b></Text>
                                        <Text>Összesen: <b>{summary.totalIncome.toLocaleString('hu-HU')} Ft</b></Text>
                                    </Box>
                                )}

                                {/* INVOICES */}
                                {summary.invoices?.length > 0 && (
                                    <Box mt={4} p={3} bg="red.50" borderRadius="md">
                                        <Text fontWeight="bold" mb={2}>📄 Számlák:</Text>
                                        <Text>0% (DRS): <b>{totalInvoiceAmounts._0.toLocaleString('hu-HU')} Ft</b></Text>
                                        <Text>5%: <b>{totalInvoiceAmounts._5.toLocaleString('hu-HU')} Ft</b></Text>
                                        <Text>18%: <b>{totalInvoiceAmounts._18.toLocaleString('hu-HU')} Ft</b></Text>
                                        <Text>27%: <b>{totalInvoiceAmounts._27.toLocaleString('hu-HU')} Ft</b></Text>
                                        <Text>Összesen: <b>{summary.invoiceExpense.toLocaleString('hu-HU')} Ft</b></Text>
                                    </Box>
                                )}

                                {/* EXPENSES */}
                                {summary.expenses?.length > 0 && (
                                    <Box mt={4} p={3} bg="orange.50" borderRadius="md">
                                        <Text fontWeight="bold" mb={2}>💸 Egyéb kiadások:</Text>
                                        <Divider my={2} />
                                        <Text>Összesen: <b>{summary.otherExpense.toLocaleString('hu-HU')} Ft</b></Text>
                                    </Box>
                                )}



                                {/* VÉGÖSSZESÍTÉS */}
                                <Box mt={4} p={3} bg="yellow.50" borderRadius="md">
                                    <Text fontWeight="bold" mb={2}>🧾 Végösszesítés (NAPI FORGALOM - SZÁMLÁK - EGYÉB):</Text>
                                    <Text>0% (DRS): <b>{totalAllAmounts._0.toLocaleString('hu-HU')} Ft</b></Text>
                                    <Text>5%: <b>{totalAllAmounts._5.toLocaleString('hu-HU')} Ft</b></Text>
                                    <Text>18%: <b>{totalAllAmounts._18.toLocaleString('hu-HU')} Ft</b></Text>
                                    <Text>27%: <b>{totalAllAmounts._27.toLocaleString('hu-HU')} Ft</b></Text>
                                    <Text>Összesen: <b>{summary.profit.toLocaleString('hu-HU')} Ft</b></Text>
                                </Box>
                            </CardBody>
                        </Card>



                        {/* SZÁMLÁK TÁBLÁZAT */}
                        <Card mt={4}>
                            <CardBody>
                                <Text fontWeight="bold" mb={2}>🧾 Számlák:</Text>

                                <SimpleGrid columns={6} spacing={5} fontSize="sm" textAlign="center">
                                    <Text fontWeight="bold">Dátum</Text>
                                    <Text fontWeight="bold">Összeg</Text>
                                    <Text fontWeight="bold">Szállító</Text>
                                    <Text fontWeight="bold">Kategória</Text>
                                    <Text fontWeight="bold">művelet</Text>
                                    <Text fontWeight="bold">művelet</Text>
                                </SimpleGrid>
                                <Box maxH="400px" overflowY="auto" mt={2}>
                                    <SimpleGrid columns={6} spacing={3} fontSize="sm" textAlign="center">
                                        {summary.invoices.map((inv, index) => (
                                            <React.Fragment key={index}>
                                                <Text>{new Date(inv.date).toLocaleDateString()}</Text>
                                                <Text>{(inv.amounts._0 + inv.amounts._5 + inv.amounts._18 + inv.amounts._27).toLocaleString('hu-HU')} Ft</Text>
                                                <Text>{inv.supplier}</Text>
                                                <Text>{inv.category}</Text>
                                                <Button

                                                    size="sm"
                                                    colorScheme="blue"
                                                    onClick={() => {
                                                        setSelectedItem(inv); // vagy inv
                                                        onOpen();
                                                    }}
                                                >
                                                    <HiPencilSquare size='md' />
                                                </Button>

                                                <Button

                                                    size="sm"
                                                    colorScheme="red"
                                                    onClick={() => handleDeleteInvoice(inv._id)}
                                                >
                                                    <MdDeleteForever size='md' />
                                                </Button>
                                            </React.Fragment>

                                        ))}

                                    </SimpleGrid>
                                </Box>

                            </CardBody>
                        </Card>

                        {/* ELADÁSOK TÁBLÁZAT */}
                        <Card mt={4}>
                            <CardBody>
                                <Text fontWeight="bold" mb={2}>🛒 Napi Forgalmi Jelentések:</Text>

                                {/* FEJLÉC */}
                                <SimpleGrid columns={6} spacing={3} fontSize="sm" textAlign="center">
                                    <Text fontWeight="bold">Dátum</Text>
                                    <Text fontWeight="bold">Végösszeg</Text>
                                    <Text fontWeight="bold"></Text>
                                    <Text fontWeight="bold"></Text>
                                    <Text fontWeight="bold">Művelet</Text>
                                    <Text fontWeight="bold">Művelet</Text>
                                </SimpleGrid>

                                {/* GÖRGETHETŐ TARTALOM */}
                                <Box maxH="400px" overflowY="auto" mt={2}>
                                    <SimpleGrid columns={6} spacing={3} fontSize="sm" textAlign="center">
                                        {summary.sales.map((sale) => (
                                            <React.Fragment key={sale._id}>
                                                <Text>{new Date(sale.date).toLocaleDateString()}</Text>
                                                <Text>{sale.totalAmount.toLocaleString('hu-HU')} Ft</Text>
                                                <Text></Text>
                                                <Text></Text>

                                                <Button
                                                    size="sm"
                                                    colorScheme="blue"
                                                    onClick={() => {
                                                        setSelectedItem(sale);
                                                        onOpen();
                                                    }}
                                                >
                                                    Részletek
                                                </Button>

                                                <Button
                                                    size="sm"
                                                    colorScheme="red"
                                                    onClick={() => handleDeleteSale(sale._id)}
                                                >
                                                    Törlés
                                                </Button>
                                            </React.Fragment>
                                        ))}
                                    </SimpleGrid>
                                </Box>
                            </CardBody>

                        </Card>
                        {/* EGYÉB KIADÁSOK TÁBLÁZAT */}
                        <Card mt={4}>
                            <CardBody>
                                <Text fontWeight="bold" mb={2}>🛒 Egyéb kiadások:</Text>

                                {/* FEJLÉC */}
                                <SimpleGrid columns={6} spacing={5} fontSize="sm" textAlign="center">
                                    <Text fontWeight="bold">Dátum</Text>
                                    <Text fontWeight="bold">Végösszeg</Text>
                                    <Text fontWeight="bold">Kategória</Text>
                                    <Text fontWeight="bold"></Text>
                                    <Text fontWeight="bold">Művelet</Text>
                                    <Text fontWeight="bold">Művelet</Text>
                                </SimpleGrid>

                                {/* GÖRGETHETŐ TARTALOM */}
                                <Box maxH="400px" overflowY="auto" mt={2}>
                                    <SimpleGrid columns={6} spacing={3} fontSize="sm" textAlign="center">
                                        {summary.expenses.map((sale) => (
                                            <React.Fragment key={sale._id}>
                                                <Text>{new Date(sale.date).toLocaleDateString()}</Text>
                                                <Text>{sale.totalAmount.toLocaleString('hu-HU')} Ft</Text>
                                                <Text>{sale.category}</Text>
                                                <Text></Text>

                                                <Button
                                                    size="sm"
                                                    colorScheme="blue"
                                                    onClick={() => {
                                                        setSelectedItem(sale);
                                                        onOpen();
                                                    }}
                                                >
                                                    Részletek
                                                </Button>

                                                <Button
                                                    size="sm"
                                                    colorScheme="red"
                                                    onClick={() => handleDeleteExpense(sale._id)}
                                                >
                                                    Törlés
                                                </Button>
                                            </React.Fragment>
                                        ))}
                                    </SimpleGrid>
                                </Box>
                            </CardBody>

                        </Card>
                        {selectedItem && (
                            <Modal isOpen={isOpen} onClose={onClose}>
                                <ModalOverlay />
                                <ModalContent>
                                    <ModalHeader>Részletek / Szerkesztés</ModalHeader>
                                    <ModalCloseButton />

                                    <ModalBody>
                                        <FormControl>
                                            <FormLabel>Dátum</FormLabel>
                                            <Input
                                                type="date"
                                                value={selectedItem.date?.substring(0, 10)}
                                                onChange={(e) => setSelectedItem(prev => ({ ...prev, date: e.target.value }))}
                                            />
                                        </FormControl>

                                        {selectedItem.amounts &&
                                            Object.entries(selectedItem.amounts).map(([key, value]) => (
                                                <FormControl mt={2} key={key}>
                                                    <FormLabel>{key.toUpperCase()} összeg</FormLabel>
                                                    <Input
                                                        type="number"
                                                        value={value}
                                                        onChange={e =>
                                                            setSelectedItem(prev => ({
                                                                ...prev,
                                                                amounts: { ...prev.amounts, [key]: Number(e.target.value) }
                                                            }))
                                                        }
                                                    />
                                                </FormControl>
                                            ))
                                        }
                                        <FormControl mt={4}>
                                            <FormLabel>Teljes összeg (automatikus)</FormLabel>
                                            <Input
                                                type="number"
                                                value={Object.values(selectedItem.amounts || {}).reduce((a, b) => a + b, 0)}
                                                isReadOnly
                                            />
                                        </FormControl>

                                        {!selectedItem.customer && (
                                            <>
                                                <FormControl mt={2}>
                                                    <FormLabel>Szállító</FormLabel>
                                                    <Input
                                                        value={selectedItem.supplier || ""}
                                                        onChange={(e) =>
                                                            setSelectedItem(prev => ({ ...prev, supplier: e.target.value }))
                                                        }
                                                    />
                                                </FormControl>

                                                <FormControl mt={2}>
                                                    <FormLabel>Kategória</FormLabel>
                                                    <Input
                                                        value={selectedItem.category || ""}
                                                        onChange={(e) =>
                                                            setSelectedItem(prev => ({ ...prev, category: e.target.value }))
                                                        }
                                                    />
                                                </FormControl>
                                            </>
                                        )}

                                    </ModalBody>

                                    <ModalFooter>
                                        <Button colorScheme="green" mr={3} onClick={handleSave}>
                                            Mentés
                                        </Button>
                                        <Button variant="ghost" onClick={onClose}>Mégse</Button>
                                    </ModalFooter>
                                </ModalContent>
                            </Modal>
                        )}


                    </Container>)}

            </Box>


        </Box>
    );
};

export default FinanceReport;
